import { useLocation } from 'react-router-dom';

import { getTabRoute, TabKey } from './config';

const TAB_KEYS: TabKey[] = [TabKey.documents, TabKey.news, TabKey.notebook, TabKey.macro];

export const useActiveTab = (organizationId: number) => {
  const { pathname } = useLocation();

  const activeTab = TAB_KEYS.find((tab) => pathname.includes(getTabRoute(tab, organizationId)));

  return activeTab ?? null;
};
